// import React, { useState } from 'react';
// import axios from 'axios';
// import { FaKey, FaTimes } from 'react-icons/fa';

// const apiUrl = process.env.REACT_APP_SERVER_URL + `/api/auth/admin/resetpassword`;

// function AdminResetPassword() {
//     const [form, setForm] = useState({
//         email: 'admin@gmail.com',
//         newPassword: '',
//         confirmPassword: '',
//         phone: ''
//     });

//     const [loading, setLoading] = useState(false);
//     const [error, setError] = useState('');
//     const [successMsg, setSuccessMsg] = useState('');

//     const handleChange = (e) => {
//         setForm({ ...form, [e.target.name]: e.target.value });
//     };

//     const resetForm = () => {
//         setForm({
//             email: '',
//             newPassword: '',
//             confirmPassword: '',
//             phone: ''
//         });
//         setError('');
//         setSuccessMsg('');
//     };

//     const handleSubmit = async (e) => {
//         e.preventDefault();
//         setLoading(true);
//         setError('');
//         setSuccessMsg('');

//         // Validation
//         if (!form.email || !form.newPassword || !form.confirmPassword || !form.phone) {
//             setError('All fields are required.');
//             setLoading(false);
//             return;
//         }

//         const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
//         if (!emailRegex.test(form.email)) {
//             setError('Please enter a valid email address.');
//             setLoading(false);
//             return;
//         }

//         if (form.newPassword.length < 6) {
//             setError('Password must be at least 6 characters long.');
//             setLoading(false);
//             return;
//         }

//         if (form.newPassword !== form.confirmPassword) {
//             setError('Passwords do not match.');
//             setLoading(false);
//             return;
//         }

//         // Phone validation (10–15 digits)
//         const phoneRegex = /^[0-9]{10,15}$/;
//         if (!phoneRegex.test(form.phone)) {
//             setError('Please enter a valid phone number (10–15 digits).');
//             setLoading(false);
//             return;
//         }

//         try {
//            const res = await axios.post(apiUrl, {
//     email: form.email,
//     newPassword: form.newPassword,
//     phone: form.phone
// });
// console.log(res);

// if (res.data.success) {
//     setSuccessMsg(res.data.msg || 'Updated successfully');

//     setForm({
//         ...form,
//         newPassword: '',
//         confirmPassword: '',
//         phone: ''
//     });
// } else {
//     setError(res.data.msg || 'Something went wrong');
// }

//         } catch (err) {
//             setError(err.response?.data?.msg || 'Failed to reset. Please try again.');
//         } finally {
//             setLoading(false);
//         }
//     };

//     return (
//         <div className="container p-5">
//             <h3><FaKey className="me-2" /> Admin Reset (Password + Phone)</h3>
//             <p className="text-muted">Reset user password and update mobile number.</p>

//             <hr />

//             {error && <div className="alert alert-danger">{error}</div>}
//             {successMsg && <div className="alert alert-success">{successMsg}</div>}

//             <div className="card shadow-sm" style={{ maxWidth: '600px' }}>
//                 <div className="card-body">
//                     <form onSubmit={handleSubmit}>

//                         {/* Email */}
//                         <div className="mb-3">
//                             <label className="form-label">User Email</label>
//                             <input
//                                 type="email"
//                                 name="email"
//                                 value={form.email}
//                                 onChange={handleChange}
//                                 className="form-control"
//                                 required
//                             />
//                         </div>

//                         {/* Phone */}
//                         <div className="mb-3">
//                             <label className="form-label">Mobile Number</label>
//                             <input
//                                 type="text"
//                                 name="phone"
//                                 value={form.phone}
//                                 onChange={handleChange}
//                                 className="form-control"
//                                 placeholder="Enter mobile number"
//                                 required
//                             />
//                         </div>

//                         {/* New Password */}
//                         <div className="mb-3">
//                             <label className="form-label">New Password</label>
//                             <input
//                                 type="text"
//                                 name="newPassword"
//                                 value={form.newPassword}
//                                 onChange={handleChange}
//                                 className="form-control"
//                                 required
//                             />
//                         </div>

//                         {/* Confirm Password */}
//                         <div className="mb-3">
//                             <label className="form-label">Confirm Password</label>
//                             <input
//                                 type="text"
//                                 name="confirmPassword"
//                                 value={form.confirmPassword}
//                                 onChange={handleChange}
//                                 className="form-control"
//                                 required
//                             />
//                         </div>

//                         {/* Buttons */}
//                         <div className="d-flex gap-2 mt-4">
//                             <button
//                                 type="submit"
//                                 className="btn btn-warning text-dark fw-bold"
//                                 disabled={loading}
//                             >
//                                 {loading ? 'Processing...' : 'Update'}
//                             </button>

//                             <button
//                                 type="button"
//                                 className="btn btn-outline-secondary"
//                                 onClick={resetForm}
//                                 disabled={loading}
//                             >
//                                 <FaTimes className="me-1" /> Clear
//                             </button>
//                         </div>

//                     </form>
//                 </div>
//             </div>
//         </div>
//     );
// }

// export default AdminResetPassword;

import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { FaKey, FaTimes } from 'react-icons/fa';

const baseUrl = process.env.REACT_APP_SERVER_URL;
const resetApi = baseUrl + `/api/auth/admin/resetpassword`;
const infoApi = baseUrl + `/api/auth/admin/info`;

function AdminResetPassword() {

    const [form, setForm] = useState({
        email: '',
        newPassword: '',
        confirmPassword: '',
        phone: ''
    });

    const [loading, setLoading] = useState(false);
    const [initialLoading, setInitialLoading] = useState(true);
    const [error, setError] = useState('');
    const [successMsg, setSuccessMsg] = useState('');

    // ✅ Fetch Admin Info on Load
    useEffect(() => {
        const fetchAdmin = async () => {
            try {
                const res = await axios.get(`${infoApi}?email=admin@gmail.com`);

                if (res.data.success) {
                    setForm((prev) => ({
                        ...prev,
                        email: res.data.data.email || '',
                        phone: res.data.data.phone || ''

                    }));
                }
            } catch (err) {
                setError('Failed to load admin data');
            } finally {
                setInitialLoading(false);
            }
        };

        fetchAdmin();
    }, []);

    const handleChange = (e) => {
        setForm({ ...form, [e.target.name]: e.target.value });
    };

    const resetForm = () => {
        setForm({
            email: '',
            newPassword: '',
            confirmPassword: '',
            phone: ''
        });
        setError('');
        setSuccessMsg('');
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError('');
        setSuccessMsg('');

        if (!form.email || !form.newPassword || !form.confirmPassword || !form.phone) {
            setError('All fields are required.');
            setLoading(false);
            return;
        }

        if (form.newPassword.length < 6) {
            setError('Password must be at least 6 characters long.');
            setLoading(false);
            return;
        }

        if (form.newPassword !== form.confirmPassword) {
            setError('Passwords do not match.');
            setLoading(false);
            return;
        }

        const phoneRegex = /^[0-9]{10,15}$/;
        if (!phoneRegex.test(form.phone)) {
            setError('Invalid phone number.');
            setLoading(false);
            return;
        }

        try {
            const res = await axios.post(resetApi, {
                email: form.email,
                newPassword: form.newPassword,
                phone: form.phone
            });

            if (res.data.success) {
                setSuccessMsg(res.data.msg || 'Updated successfully');

                setForm((prev) => ({
                    ...prev,
                    newPassword: '',
                    confirmPassword: ''
                }));
            } else {
                setError(res.data.msg || 'Something went wrong');
            }

        } catch (err) {
            setSuccessMsg('');
            setError(err.response?.data?.msg || 'Failed to reset.');
        } finally {
            setLoading(false);
        }
    };

    // ✅ Loading state before data loads
    if (initialLoading) {
        return <div className="container p-5">Loading admin data...</div>;
    }

    return (
        <div className="container p-5">
            <h3><FaKey className="me-2" /> Admin Reset</h3>
            <p className="text-muted">Update password and mobile number.</p>

            <hr />

            {error && <div className="alert alert-danger">{error}</div>}
            {successMsg && <div className="alert alert-success">{successMsg}</div>}

            <div className="card shadow-sm" style={{ maxWidth: '600px' }}>
                <div className="card-body">
                    <form onSubmit={handleSubmit}>

                        {/* Email */}
                        <div className="mb-3">
                            <label className="form-label">Email</label>
                            <input
                                type="email"
                                name="email"
                                value={form.email}
                                onChange={handleChange}
                                className="form-control"
                                readOnly   // 🔒 prevent accidental change
                            />
                        </div>

                        {/* Phone */}
                        <div className="mb-3">
                            <label className="form-label">Mobile Number</label>
                            <input
                                type="text"
                                maxLength={10}
                                name="phone"
                                value={form.phone}
                                onChange={handleChange}
                                className="form-control"
                            />
                        </div>

                        {/* Password */}
                        <div className="mb-3">
                            <label className="form-label">New Password</label>
                            <input
                                type="text"
                                name="newPassword"
                                value={form.newPassword}
                                onChange={handleChange}
                                className="form-control"
                            />
                        </div>

                        <div className="mb-3">
                            <label className="form-label">Confirm Password</label>
                            <input
                                type="text"
                                name="confirmPassword"
                                value={form.confirmPassword}
                                onChange={handleChange}
                                className="form-control"
                            />
                        </div>

                        <div className="d-flex gap-2 mt-4">
                            <button
                                type="submit"
                                className="btn btn-warning fw-bold"
                                disabled={loading}
                            >
                                {loading ? 'Processing...' : 'Update'}
                            </button>

                            <button
                                type="button"
                                className="btn btn-outline-secondary"
                                onClick={resetForm}
                                disabled={loading}
                            >
                                <FaTimes className="me-1" /> Clear
                            </button>
                        </div>

                    </form>
                </div>
            </div>
        </div>
    );
}

export default AdminResetPassword;